module.exports = __webpack_public_path__ + "static/media/avatar_37.ceeee660.svg";